import React from "react"
import PropTypes from "prop-types"
import {get} from "lodash"

import {Label} from "@irati-web/insights/src/ui/FormItem"
import {Input} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import id from "@irati/utils/id"
import {Para} from "@irati-web/insights/src/ui/Labels"
import {injectIntl} from "@irati/utils/lang"

const PROPERTY = "preferences.placeholders.tenant"

export const schema = (props, required) => {
  const {formatMessage} = props
  return Validation.string(required ? formatMessage({id: "insights.validation.required"}) : "")
}

const Tenant = ({intl, schedule, onChange, required, label, hint, validation, placeholder, className, ...props}) => {
  /** @todo too much of a rewrite now, but should move this to getDerivedStateFromProps */
  const intlLabel = label || props.formatMessage({id: `insights.fields.schedule.${PROPERTY}.label`})
  const intlHint = hint || props.formatMessage({id: `insights.fields.schedule.${PROPERTY}.hint`})
  const intlPlaceholder = placeholder || props.formatMessage({id: `insights.fields.schedule.${PROPERTY}.placeholder`})

  return (
    <Input
      {...props}
      className={`${className} clearfix`}
      id={id("TenantPublicName", props)}
      name={PROPERTY}
      placeholder={intlPlaceholder}
      value={get(schedule, PROPERTY)}
      onChange={(value) => onChange(schedule, PROPERTY, value)}
      label={
        <>
          <Label bold>{intlLabel}</Label>
          <Para>{intlHint}</Para>
        </>
      } />
  )
}

Tenant.propTypes = {
  intl: PropTypes.object.isRequired,
  schedule: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  label: PropTypes.string,
  validation: PropTypes.object,
  hint: PropTypes.string,
  placeholder: PropTypes.string,
  formatMessage: PropTypes.func.isRequired
}

Tenant.defaultProps = {
  required: true,
  label: null,
  placeholder: null,
  hint: null,
  validation: null,
  id: PROPERTY
}

export default injectIntl(Tenant)
